import { createContext, useContext } from 'react';

export const RouteTrackerContext = createContext({
  prevRoute: '',
  currentRoute: '',
});

export const useRouteTracker = () => useContext(RouteTrackerContext);
